/* ═══════════════════════════════════════════════════════
   Topscent Scratch Popup v3
   Clean hard-edge scratch, reveal visible behind foil,
   Claim → Email two-step, 30% threshold, 60px brush.
   ═══════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var KLAVIYO_LIST_ID = 'Y5MC64';
  var LS_KEY = 'topscent_scratch_shown';
  var DELAY_MS = 10000;
  var REVEAL_THRESHOLD = 0.50;
  var PRIZE_DELAY_MS = 600;

  // ── Guards ──
  function alreadyShown() {
    try { return localStorage.getItem(LS_KEY) === '1'; } catch (e) { return false; }
  }
  function markShown() {
    try { localStorage.setItem(LS_KEY, '1'); } catch (e) { /* silent */ }
  }
  function isKnownProfile() {
    try {
      var kl = window._klOnsite || window.klaviyo;
      if (kl && typeof kl.isIdentified === 'function') return kl.isIdentified();
    } catch (e) { /* silent */ }
    return false;
  }

  // ── State ──
  var popup, closeBtn, canvas, ctx, card, claimBtn, formWrap;
  var form, emailInput, submitBtn, successEl, errorEl;
  var shown = false;
  var revealed = false;
  var scratching = false;
  var lastX = 0, lastY = 0;
  var canvasW = 0, canvasH = 0;

  function init() {
    if (alreadyShown() || isKnownProfile()) return;

    popup = document.getElementById('topscent-scratch-popup');
    if (!popup) return;

    closeBtn = document.getElementById('topscent-scratch-close');
    canvas = document.getElementById('topscent-scratch-canvas');
    card = document.querySelector('.topscent-scratch__card');
    claimBtn = document.getElementById('topscent-scratch-claim');
    formWrap = document.getElementById('topscent-scratch-form-wrap');
    form = document.getElementById('topscent-scratch-form');
    emailInput = document.getElementById('topscent-scratch-email');
    submitBtn = document.getElementById('topscent-scratch-submit');
    successEl = document.getElementById('topscent-scratch-success');
    errorEl = document.getElementById('topscent-scratch-error');

    setupTriggers();
  }

  // ── Triggers: 25s + exit intent ──
  function setupTriggers() {
    var timer = setTimeout(function () { show(); }, DELAY_MS);

    function onMouseLeave(e) {
      if (e.clientY <= 0) {
        show();
        document.removeEventListener('mouseleave', onMouseLeave);
        clearTimeout(timer);
      }
    }
    document.addEventListener('mouseleave', onMouseLeave);
  }

  // ── Show ──
  function show() {
    if (shown) return;
    if (alreadyShown() || isKnownProfile()) return;
    shown = true;
    markShown();
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setupCanvas();
    bindEvents();
  }

  // ── Hide ──
  function hide() {
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // ── Events ──
  function bindEvents() {
    closeBtn.addEventListener('click', hide);
    popup.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hide();
    });
    // Only close via X button — no background click dismiss
    // Claim button → show email form
    if (claimBtn) {
      claimBtn.addEventListener('click', function () {
        claimBtn.style.display = 'none';
        formWrap.classList.add('is-visible');
        emailInput.focus();
      });
    }
    form.addEventListener('submit', handleSubmit);
  }

  // ═══════════════════════════════════════════════════════
  // CANVAS — OPAQUE GOLD FOIL, HARD-EDGE ERASE
  // ═══════════════════════════════════════════════════════
  function setupCanvas() {
    var dpr = window.devicePixelRatio || 1;
    var rect = card.getBoundingClientRect();
    canvasW = rect.width;
    canvasH = rect.height;

    canvas.width = canvasW * dpr;
    canvas.height = canvasH * dpr;
    canvas.style.width = canvasW + 'px';
    canvas.style.height = canvasH + 'px';

    ctx = canvas.getContext('2d', { willReadFrequently: true });
    ctx.scale(dpr, dpr);

    // Draw opaque gold foil
    drawFoil();

    // Pointer events
    canvas.addEventListener('pointerdown', startScratch);
    canvas.addEventListener('pointermove', doScratch);
    canvas.addEventListener('pointerup', stopScratch);
    canvas.addEventListener('pointerleave', stopScratch);
    canvas.addEventListener('pointercancel', stopScratch);
  }

  function drawFoil() {
    // Solid gold gradient — enriched
    var grad = ctx.createLinearGradient(0, 0, canvasW, canvasH);
    grad.addColorStop(0, '#D4A847');
    grad.addColorStop(0.3, '#C4902A');
    grad.addColorStop(0.5, '#E6C564');
    grad.addColorStop(0.7, '#9B7420');
    grad.addColorStop(1, '#D4A847');
    ctx.fillStyle = grad;
    ctx.fillRect(0, 0, canvasW, canvasH);

    // "SCRATCH HERE" text — clean, no scribbles
    ctx.fillStyle = 'rgba(255, 255, 255, 0.92)';
    ctx.font = '700 20px "Montserrat", "Inter", sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('SCRATCH HERE', canvasW / 2, canvasH / 2);

    // NOW set composite to erase — all future draws will cut through
    ctx.globalCompositeOperation = 'destination-out';
  }

  // ── Scratch: hard-edge circle erase (no feathering) ──
  function getPos(e) {
    var rect = canvas.getBoundingClientRect();
    return { x: e.clientX - rect.left, y: e.clientY - rect.top };
  }

  function startScratch(e) {
    if (revealed) return;
    scratching = true;
    canvas.setPointerCapture(e.pointerId);
    var pos = getPos(e);
    lastX = pos.x;
    lastY = pos.y;
    // Stamp a circle at the start point
    stamp(pos.x, pos.y);
  }

  function doScratch(e) {
    if (!scratching || revealed) return;
    var pos = getPos(e);
    // Draw filled circles along the path for a clean, hard-edged erase
    var dx = pos.x - lastX;
    var dy = pos.y - lastY;
    var dist = Math.sqrt(dx * dx + dy * dy);
    var steps = Math.max(1, Math.floor(dist / 8));
    for (var i = 0; i <= steps; i++) {
      var t = i / steps;
      var x = lastX + dx * t;
      var y = lastY + dy * t;
      stamp(x, y);
    }
    lastX = pos.x;
    lastY = pos.y;
    // No reveal check here — only on stop
  }

  function stamp(x, y) {
    ctx.beginPath();
    ctx.arc(x, y, 30, 0, Math.PI * 2);
    ctx.fill();
  }

  function stopScratch(e) {
    if (!scratching) return;
    scratching = false;
    if (e && e.pointerId !== undefined) {
      try { canvas.releasePointerCapture(e.pointerId); } catch (err) { /* ok */ }
    }
    // Check reveal only when user stops scratching
    checkReveal();
  }

  // ── Reveal check ──
  function checkReveal() {
    if (revealed) return;
    var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    var pixels = imageData.data;
    var cleared = 0;
    var sampled = 0;
    for (var i = 3; i < pixels.length; i += 32) {
      sampled++;
      if (pixels[i] === 0) cleared++;
    }
    if (sampled > 0 && (cleared / sampled) >= REVEAL_THRESHOLD) {
      revealPrize();
    }
  }

  function revealPrize() {
    revealed = true;
    card.classList.add('is-revealed');
    setTimeout(function () {
      popup.classList.add('is-prize-state');
    }, PRIZE_DELAY_MS);
  }

  // ═══════════════════════════════════════════════════════
  // KLAVIYO SUBMISSION
  // ═══════════════════════════════════════════════════════
  function handleSubmit(e) {
    e.preventDefault();
    var email = (emailInput.value || '').trim();
    if (!email || !isValidEmail(email)) {
      showError('Please enter a valid email.');
      return;
    }
    clearMessages();
    submitBtn.disabled = true;
    submitBtn.textContent = '...';

    var companyId = getKlaviyoCompanyId();
    if (companyId) {
      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Scratch Popup',
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email }
              }
            }
          },
          relationships: {
            list: {
              data: { type: 'list', id: KLAVIYO_LIST_ID }
            }
          }
        }
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + companyId, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-02-15' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          if (res.ok || res.status === 202) { onSuccess(); }
          else { throw new Error('status ' + res.status); }
        })
        .catch(function () { fallbackSubmit(email); });
    } else {
      fallbackSubmit(email);
    }
  }

  function fallbackSubmit(email) {
    var formData = new FormData();
    formData.append('email', email);
    formData.append('g', KLAVIYO_LIST_ID);

    fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
      method: 'POST',
      body: formData
    })
      .then(function (res) {
        if (res.ok) { onSuccess(); }
        else { onError(); }
      })
      .catch(function () { onError(); });
  }

  function onSuccess() {
    showSuccess('You\u2019re in. Check your inbox for the code.');
    submitBtn.textContent = 'DONE';
    emailInput.disabled = true;
    // Silently apply EXPRESS48 discount to the session
    try { fetch('/discount/EXPRESS48', { redirect: 'follow' }); } catch (e) { /* silent */ }
  }

  function onError() {
    showError('Something went wrong. Try again.');
    submitBtn.disabled = false;
    submitBtn.textContent = 'JOIN';
  }

  function getKlaviyoCompanyId() {
    try {
      var scripts = document.querySelectorAll('script[src*="klaviyo.com"]');
      for (var i = 0; i < scripts.length; i++) {
        var match = scripts[i].src.match(/company_id[=\/]([A-Za-z0-9]+)/);
        if (match) return match[1];
      }
      if (window._learnq && window._learnq.account) return window._learnq.account;
    } catch (e) { /* silent */ }
    return '';
  }

  // ── Helpers ──
  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }
  function showError(msg) {
    if (errorEl) errorEl.textContent = msg;
    if (successEl) successEl.textContent = '';
  }
  function showSuccess(msg) {
    if (successEl) successEl.textContent = msg;
    if (errorEl) errorEl.textContent = '';
  }
  function clearMessages() {
    if (errorEl) errorEl.textContent = '';
    if (successEl) successEl.textContent = '';
  }

  // ── Boot ──
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
